import React from 'react';
import PropTypes from 'prop-types';
import api from '@tutorbot/directory-api';
import Landing from '../landing';

const SubLanding = ({ data, courses, type }) => (
  <Landing data={courses} type={type} category={data} />
);

SubLanding.propTypes = {
  courses: PropTypes.array,
  data: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
};

SubLanding.defaultProps = {
  courses: [],
};

SubLanding.getInitialProps = async ({ res, query: { type, category } }) => {
  let courses = [];

  const categoryData = await api()
    .categories.where('label', category)
    .first();

  const { id: categoryId } = categoryData;

  const courseTypeData = await api()
    .courseTypes.where('category', categoryId)
    .where('label', type)
    .first();

  const languageData = await api()
    .languages.where('category', categoryId)
    .where('label', type)
    .first();

  if (languageData) {
    courses = (await api()
      .courses.where('language.label', type)
      .limit(6)
      .get()).data;
  } else if (courseTypeData) {
    courses = (await api()
      .courses.where('coursetypes.label', type)
      .limit(6)
      .get()).data;
  } else {
    res.statusCode = 404;
    return null;
  }

  return {
    data: courseTypeData || {
      ...languageData,
      title: languageData.Name,
      title_hy: languageData.Name_hy,
      title_ru: languageData.Name_ru,
      title_de: languageData.Name_de,
    },
    category: categoryData,
    courses,
    type,
  };
};

export default SubLanding;
